import React from 'react';

export default function isTokenExpired() {
  const token = localStorage.getItem("token");
  if (!token) return true;

  try {
    const payloadBase64 = token.split(".")[1];
    const payload = JSON.parse(atob(payloadBase64));

    if (!payload.exp) return true;

    const now = Date.now() / 1000;
    return payload.exp < now;
  } catch (err) {
    return true;
  }
}
